import { createContext, useContext, useState } from "react";
import {
  emptyAgenciasFilters,
  type AgenciasFilters,
} from "@/components/admin/AgenciasFiltersSheet";

const Ctx = createContext<{
  filters: AgenciasFilters;
  setFilters: (f: AgenciasFilters) => void;
  open: boolean;
  setOpen: (v: boolean) => void;
} | null>(null);

export function AgenciasFiltersProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [filters, setFilters] = useState<AgenciasFilters>(emptyAgenciasFilters);
  const [open, setOpen] = useState(false);
  return (
    <Ctx.Provider value={{ filters, setFilters, open, setOpen }}>
      {children}
    </Ctx.Provider>
  );
}

const noopFilters = {
  filters: emptyAgenciasFilters,
  setFilters: () => {},
  open: false,
  setOpen: () => {},
};

export function useAgenciasFilters() {
  const v = useContext(Ctx);
  return v ?? noopFilters;
}
